<div class="error_container">
  <div>Icon Goes Here...</div>
  >
  <img class="error_pic" src="../../../../assets/svg/icons/error_page.svg" width="450px" alt="server error" />
  <h2 class="error_message">Oops! You are not authorized to access this resource...</h2>
  <h2 class="error_number">ERR 403: Access Denied</h2>
  <button class="button_main_white" routerLink="/"><mat-icon>home</mat-icon>BACK TO HOME</button>
</div>
